import { module } from 'angular';

import { default as domainTreeName, DomainTree } from './domain-tree.component.ajs';

export default module('hypervision.domain-tree', []).component(domainTreeName, new DomainTree()).name;
